import React, { useState } from 'react';
import { Button, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const TruncatableText = ({ text, limit = 123, ...props }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Only truncate if text exceeds limit
  const isTruncated = text.length > limit;
  const displayText = isExpanded || !isTruncated ? text : `${text.slice(0, limit) }…`;

  return (
    <Text {...props}>
      {displayText}
      {' '}
      {isTruncated && (
        <Button
          fontWeight="medium"
          size="xs"
          variant="textPrimary"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </Text>
  );
};

TruncatableText.propTypes = {
  text: PropTypes.string.isRequired,
  limit: PropTypes.number
};

export default TruncatableText;
